import OrderListing from "./orderListing.container";

export default OrderListing;
